import React, { Component, Fragment } from 'react';

import Abs from './Abs';
import Airbag from './Airbag';
import DiscBrake from './DiscBrake';
import Light from './Light';
import Tire from './Tire';

import './AlarmIcon.css';

export default class AlarmIcon extends Component {
  getType = type => {
    switch (type) {
      case 'EXT_BATT_VOLTAGE':
        return 'battery';
      case 'OIL_PRESSURE_WARNING':
        return 'oil-press';
      case 'OIL_LEVEL_WARNING':
        return 'oil';
      case 'WATER_IN_FUEL_INDICATOR':
        return 'water';
      case 'ALTERNATOR_WARNING':
        return 'engine';
      default:
        return type;
    }
  };

  isSafety = type => {
    switch (type) {
      case 'ABS_WARNING':
        return true;
      case 'PASSENGER_AIRBAG_WARNING':
        return true;
      case 'TIRE_PRESSURE_WARNING':
        return true;
      case 'AIRBAG_WARNING':
        return true;
      case 'BRAKE_LEVEL_WARNING':
        return true;
      case 'LAMP_WARNING':
        return true;
      default:
        return false;
    }
  };
  getSafetyIcon = type => {
    switch (type) {
      case 'ABS_WARNING':
        return <Abs className={`AlarmIcon Safety abs`} />;
      case 'PASSENGER_AIRBAG_WARNING':
        return <Airbag className={`AlarmIcon Safety pa`} />;
      case 'TIRE_PRESSURE_WARNING':
        return <Tire className={`AlarmIcon Safety tp`} />;
      case 'AIRBAG_WARNING':
        return <Airbag className={`AlarmIcon Safety ab`} />;
      case 'BRAKE_LEVEL_WARNING':
        return <DiscBrake className={`AlarmIcon Safety bl`} />;
      case 'LAMP_WARNING':
        return <Light className={`AlarmIcon Safety li`} />;
      default:
        return <div>no icon</div>;
    }
  };

  render() {
    const { style, type, className } = this.props;
    return (
      <Fragment>
        {this.isSafety(type) && this.getSafetyIcon(type)}
        {!this.isSafety(type) && (
          <i className={`AlarmIcon icon-alarms-${this.getType(type)} ${className}`} style={{ ...style }}>
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </i>
        )}
      </Fragment>
    );
  }
}
